import { gql } from "@grandvisionhq/graphql";
import { failureFragment } from "../../../fragments/operations/fragments/failure-fragment.js";
import { shoppinglistVariantDetailsFragment } from "../../../fragments/operations/fragments/shopping-list.js";
const GET_SHOPPING_LIST = gql`
  query getShoppingList($shoppinglistId: String!) {
    shoppinglistById(shoppinglistId: $shoppinglistId) {
      shoppinglist {
        id
        items {
          name
          quantity
          sku
          product {
            brand
            ... on ContactLensProduct {
              id
              productTypeDetails {
                replacementFrequencyAllLocales {
                  value
                  locale
                }
              }
            }
            ... on FrameProduct {
              id
              productTypeDetails {
                offerings {
                  isPrescriptionNeeded
                }
                isOfferedWithPrescriptions
              }
            }
            slug
          }
          variant {
            ...ShoppinglistVariantDetailsFragment
          }
        }
      }
      failure {
        ...ShoppinglistFailureFragment
      }
    }
  }
  ${shoppinglistVariantDetailsFragment}
  ${failureFragment}
`;
export {
  GET_SHOPPING_LIST as default
};
//# sourceMappingURL=get-shopping-list.js.map
